<script setup lang="ts">
import { AnnuitiesPremium } from "@/entities/premium";
import { LINKS } from "@/constants/links";
import Document from "./Document.vue";

defineProps<{
    premium: AnnuitiesPremium;
    quoteNumber: string;
}>();
</script>

<template>
    <div class="col-12 documents col-md-5 mb-3 bg-light p-4">
        <h5 class="results-header">
            Important documents
        </h5>
        <div>
            <h6 class="chalet blue pt-3 font-weight-bold">
                {{ premium.company.name }} documents
            </h6>
            <Document
                :url="`/documents/${quoteNumber}/${premium.premiumId}/keyfacts`"
                label="Quote (Key facts)"
                class-name="product-summary"
            />
            <Document
                :url="premium.documents?.keyFeatures"
                label="Key features"
                class-name="key-features"
            />
            <Document
                :url="premium.company.privacyUrl"
                label="Privacy Notice"
                class-name="privacy-policy"
            />
            <Document
                :url="premium.documents?.termsConditions"
                label="Terms &amp; conditions"
            />
        </div>
        <div class="pt-1">
            <h6 class="chalet blue pt-4 font-weight-bold">
                Annuity Ready documents
            </h6>
            <Document
                :url="LINKS.ANNUITY_TERMS_AND_CONDITIONS"
                label="Terms &amp; conditions"
            />
            <Document
                :url="LINKS.ANNUITY_PRIVACY_POLICY"
                label="Privacy policy"
            />
            <Document
                :url="`${LINKS.DEMANDS_AND_NEEDS}/${quoteNumber}`"
                label="Demands &amp; needs statement"
            />
            <Document
                :url="LINKS.OUR_SERVICES_LINK"
                label="Our services"
            />
        </div>
    </div>
</template>
